/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const CodeIcon = ({
  className,
  style,
  color = '#F8F3FF',
  onClick,
  size = 13,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M5.15768 12.1835L4.59345 12.0258C4.52123 12.0058 4.4806 11.9325 4.50091 11.8614L7.67644 0.910744C7.69675 0.839651 7.77123 0.79966 7.84345 0.819655L8.40769 0.977395C8.47991 0.99739 8.52053 1.07071 8.50022 1.1418L5.3247 12.0902C5.30439 12.1613 5.22765 12.2035 5.15768 12.1835ZM3.45143 9.39978L3.86897 8.93545C3.91185 8.8888 3.90508 8.8177 3.85768 8.77771L1.12678 6.50049L3.85768 4.22327C3.90508 4.18328 3.91185 4.11218 3.86897 4.06553L3.45143 3.6012C3.41081 3.55454 3.33859 3.5501 3.29119 3.59231L0.0389323 6.41829C-0.0129774 6.46272 -0.0129774 6.54048 0.0389323 6.58491L3.29119 9.41089C3.33859 9.45088 3.41081 9.44644 3.45143 9.39978ZM9.70994 9.40867L12.9622 6.58269C13.0141 6.53826 13.0141 6.4605 12.9622 6.41607L9.70994 3.59231C9.66255 3.55232 9.59258 3.55676 9.5497 3.6012L9.13217 4.06553C9.08928 4.11218 9.09606 4.18328 9.14345 4.22327L11.8744 6.50049L9.14345 8.77771C9.09606 8.8177 9.08928 8.8888 9.13217 8.93545L9.5497 9.39978C9.59033 9.44644 9.66255 9.45088 9.70994 9.40867Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <path d="M0 0H13V13H2C0.89543 13 0 12.1046 0 11V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
